import { Text, Pressable } from 'react-native'
import React from 'react'
import { StyleSheet } from 'react-native-unistyles'

const MetaDataItem = ({label, value, onPress = undefined}) => {
    
  return (
    <Pressable style={styles.card(!!onPress)} onPress={onPress}>
        <Text style={styles.field_label}>{label}</Text>
        {typeof value == "string" ? <Text style={styles.field_value(!!onPress)}>{value}</Text> : value}
    </Pressable>
  )
}


const styles = StyleSheet.create(({colors, fonts, shadows}) => ({
    card: (isPressable) => ({
        backgroundColor: colors.surface,
        borderRadius:8,
        marginVertical:5,
        paddingHorizontal:15,
        paddingVertical:10,
        flexDirection:"row", 
        justifyContent:"space-between",
        borderColor:colors.border,
        borderWidth:1,
        boxShadow:shadows.card,
        alignItems:"center",
        _web:{
            transition:"all 0.2s ease-in-out",
            cursor:isPressable ? "pointer" : "default",
            _hover:{
                backgroundColor: isPressable ? colors.surfaceVariant : colors.surface,
            }
        }
    }),
    field_label:{
        color: colors.text,
        fontSize:14,
        textAlign:"left", 
        fontFamily: fonts.heading,
        flexGrow:1
    },
    field_value: (isPressable) => ({
        color: isPressable ? colors.primary : colors.textSecondary,
        fontFamily: fonts.body,
        fontSize:14,
        textAlign:"right",
        flexGrow:1
    })
}))

export default React.memo(MetaDataItem);